import { setRangeMax } from './helpers';

export const setConstructionYearMax = setRangeMax('house_year');
